module.exports = __webpack_public_path__ + "img/can-rot.2e9b3b42.png";